<template>
  <div class="container">
    <avue-crud
      ref="crud-user"
      :option="options"
      :data="data"
      :page.sync="page"
      @on-load="getList"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @refresh-change="refreshChange"
      @search-reset="searchChange"
      @search-change="searchChange"
    >
      <template #menu="{row,size,type}">
        <el-button icon="el-icon-edit" :size="size" :type="type" @click="userSetRole(row)">分配角色</el-button>
      </template>
    </avue-crud>
    <!--授权管理-->
    <el-drawer
      :title="'授权>' + current.rname" ref="drawerAuthorize"
      :visible.sync="drawer"
      @close="close()"
    >
      <el-table
        class="table"
        :data="roleList"
        style="width: 100%"
        row-key="id"
        border
        ref="authTable"
        @selection-change="handleSelectionChange"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="name" label="角色"></el-table-column>
      </el-table>
      <div class="footer-btns">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="onSave()">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { addObj, setUserRole, fetchList,delObj } from '@/page/system/api/user'
import { baseUrl } from "@/config";
import { rolefetchList } from '@/page/system/api/role'
export default {
  name: "sys-user",
  data() {
    var checkPhone = (rule, value, callback) => {
    if (!value) {
      callback(new Error('请输入手机号'))
    } else {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (!reg.test(value)) {
        callback(new Error('请输入手机号'))
      }else{
        callback()
      }
    }
  };
    return {
      drawer: false,
      checkid: '',
      roleList: [],
      current: {},
      options: {
        index: true,
        indexLabel: '序号',
        indexWidth: 60,
        labelWidth: 120,
        menuAlign: 'center',
        searchMenuSpan: 8,
        align: 'center',
        column: [{
          label: '用户名',
          prop: 'uname',
          span: 24,
          search:true,
          rules: [{
            required: true,
            message: '请输入用户名'
          }
          ]
        }
        ,{
          label: '姓名',
          prop: 'rname',
          search:true,
          span: 24,
          rules: [{
            required: true,
            message: '请输入姓名'
          }
          ]
        }
        , {
          label: '手机号',
          prop: 'telephone',
          span: 24,
          rules: [{
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          { 
            validator: checkPhone,
            trigger: 'blur' 
          }
          ]
        }
        , {
          label: '所属部门',
          prop: 'dept_id',
          type: 'select',
          span: 24,
          hide: true,
          showColumn:false,
          props: {
            label: 'text',
            value: 'id'
          },
          dataType:'string',
          dicUrl:`${baseUrl}/system/dept/deptcombo`,
          rules: [{
            required: true,
            message: '请选择部门',
            trigger: 'change'
          }]
        }, {
          label: '角色',
          prop: 'role_names',
          overHidden: true,
          span: 24,
          addDisplay: false,
          editDisplay: false
        }, 
        {
          label: '角色',
          prop: 'role_ids',
          hide:true,
          type:'select',
          showColumn:false,
          span: 24,
          dataType:'string',
          props: {
            label: 'name',
            value: 'id'
          },
          dicUrl:`${baseUrl}/system/role/listdata`,
          rules: [{
            required: true,
            message: '请选择角色',
            trigger: 'blur'
          }]
        }, 
        {
          label: '部门',
          prop: 'dept_qcname',
          overHidden: true,
          addDisplay: false,
          editDisplay: false,
          span: 24
        }
        ]
      },
      data: [],
      //pageSize默认10，pagerCount默认7(最多显示几个数字页码块),currentPage默认1,pageSizes默认
      page: { total: 0, currentPage: 1, pageSize: 10 },
      params: {},

    };
  },

  mounted() {},
  methods: {
    // 设置角色
    userSetRole(row){
      console.log('row', row)
      this.current = row;
      this.drawer = true
      rolefetchList().then(res => {
        if(res.data.success) {
          this.roleList = res.data.data
          this.roleList.map(e => {
            if(row.role_ids.split(',').includes(e.id.toString())) {
              this.$nextTick(()=>{
                  this.$refs.authTable.toggleRowSelection(e, true)
              })
            }
          })
        }
        // console.log('res', res)
      })
    },
    // 用户列表
    getList() {
      const params = Object.assign(
        {
          page: this.page.currentPage,
          limit: this.page.pageSize,
        },
        this.params
      );
      fetchList(params).then((res) => {
          if (res.data.success) {
            this.page.total = res.data.data.total||0;
            this.data = res.data.data.list||[];
          }
        });
    },
    // 用户设置角色
    onSave (){
      setUserRole({id: this.current.id, role_ids: this.checkid}).then(res => {
        console.log('res', res)
        if(res.data.success) {
          this.$message.success('操作成功');
          this.drawer = false
          this.getList()
        }
      })
    },
    handleSelectionChange(data) {
      console.log('data', data)
      this.checkid = data.map(item => {
        return item.id
      }).join(',')
    },  
    rowSave(row, done) {
      addObj(row)
        .then((resp) => {
          if (resp.data.success) {
            this.$message.success("新增成功");
            this.getList();
          }
          done();
        });
    },
    rowUpdate(row, index, done) {
      console.log(111)
        addObj(row).then((resp) => {
          if (resp.data.success) {
            this.$message.success("修改成功");
            this.getList();
          }
          done();
        });
    },
    rowDel(row) {
      this.$confirm("是否删除此选中记录?", "提示", { type: "warning" })
        .then(() => {
          delObj({ id: row.id }).then((resp) => {
            if (resp.data.success) {
              this.$message.success("删除成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    searchChange(params, done) {
      if (done) done();
      this.params = params;
      this.page.currentPage = 1;
      this.getList();
    },
    refreshChange() {
      this.getList();
    },
    close(){
      console.log('111', 111)
      this.drawer = false
      console.log('this.drawer', this.drawer)
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
:deep(.table) {
 tr {
  background: #141C3A;
 }
 th.el-table__cell {
  background: #141C3A;
 }
}

:deep(.el-drawer__header) {
  color: #fff;
}
</style>